import { assignModel } from '@/common/helpers/assignModel';

interface PavillionColorViboxChroma {
  abs: number;
  grade: string;
  position: number;
}

interface PavillionColorViboxWarning {
  code: 'notYellowishRange' | string;
  message: string;
}

export class PavillionColorViboxMetricModel {
  val!: number;
  title!: string;
  chroma?: PavillionColorViboxChroma;
  maxChroma?: PavillionColorViboxChroma;
  minChroma?: PavillionColorViboxChroma;
  gradeProbability?: Record<string, number>;
  warnings?: PavillionColorViboxWarning[];
}

export default class PavillionColorViboxMetric extends PavillionColorViboxMetricModel {
  constructor(model: PavillionColorViboxMetricModel) {
    super();

    assignModel<PavillionColorViboxMetricModel>(this, model);
  }

  get notYellowishMessage() {
    return this.warnings?.find(({ code, message }) => code === 'notYellowishRange' && message)?.message || null;
  }
}
